<template>
  <div class="hzc-industry-dynamics">
    <div>当前位置：<span @click="back" style="cursor: pointer">焦化苯</span> > 相关产品价格</div>
    <div class="content">
      <div class="header">
        <em></em>
        <p>相关产品价格</p>
        <div class="btn fr" @click="search">搜索</div>
        <input class="fr" v-model="likeTitleName" type="text" placeholder="请输入关键词">
      </div>
      <div class="tabs">
        <div @click="changeTabs(1)" :class="{'hover':flag === 1}">苯乙烯</div>
        <div @click="changeTabs(2)" :class="{'hover':flag === 2}">其他</div>
      </div>
      <ul>
        <li v-for="(item,index) in list" :key="index">
          <img src="../../../assets/home/liebiaoqian.png" alt="">
          <p v-if="flag === 1" @click="goDetail(item.id)">{{ item.titleName }}</p>
          <p v-if="flag === 2" @click="goDetail(item.completeOriginalDate)">{{ item.date + '相关产品价格' }}</p>
          <span v-if="flag === 1" class="fr">{{ item.showYearTime }}</span>
          <span v-if="flag === 2" class="fr">{{ item.completeOriginalDate }}</span>
          <em v-if="(index+1)%5 === 0 && (index+1) !== list.length" class="xiaxuxian"></em>
        </li>
      </ul>
    </div>
    <div style="text-align: center;">
      <span
          style="vertical-align:middle;display: inline-block;width: 50px;height: 32px;text-align: center;line-height: 32px;background-color: rgb(244, 244, 245);font-weight: normal;cursor: pointer;"
          @click="goFirst">首页</span>
      <el-pagination
          style="margin: 24px 0;display: inline-block;vertical-align:middle;"
          background
          prev-text="上一页"
          next-text="下一页"
          :page-size="size"
          :current-page="page"
          @current-change="changePage"
          layout="prev, pager, next,slot, total,jumper"
          :total="total">
        <span
            style="margin-right:10px;display: inline-block;width: 50px;height: 32px;text-align: center;line-height: 32px;background-color: rgb(244, 244, 245);font-weight: normal;cursor: pointer;"
            @click="goLast">末页</span>
      </el-pagination>
      <span
          style="margin-left:20px;color:#FFF;background-color:#D3131A;margin-right:10px;display: inline-block;width: 50px;height: 32px;text-align: center;line-height: 32px;font-weight: normal;cursor: pointer;">跳转</span>
    </div>
  </div>
</template>

<script>
import {
  productPricedList,
  productPricedListBen
} from '@/api/cokeBenzene'

export default {
  data() {
    return {
      list: [],
      page: 1,
      size: 15,
      total: 0,
      likeTitleName: '',
      flag: 1,
    }
  },
  created() {
    if (this.$route.query['flag']) {
      this.flag = Number(this.$route.query['flag']);
    }
    this.getList();
  },
  methods: {
    // 列表
    getList() {
      if (this.flag === 1) {
        productPricedListBen({
          pageNum: this.page, pageSize: this.size,
          likeTitleName:this.likeTitleName,
          sourceType: 21,
        }).then(res => {
          this.list = res.rows;
          this.total = res.total;
        })
      } else {
        productPricedList({
          pageNum: this.page,
          pageSize: this.size,
          likeTitleName:this.likeTitleName,
          dataType: 1,
          dictDataType: 'issue_petroleum_benzene_relevant_price'
        }).then(res => {
          this.list = res.rows;
          this.total = res.total;
        })
      }
    },
    /**
     * 搜索
     */
    search() {
      this.page = 1;
      this.getList()
    },
    /**
     * 前往详情页
     */
    goDetail(id) {
      if (this.flag === 1) {
        this.$router.push({path: `/cokeBenzene/productPriceContent`, query: {id}})
      } else {
        this.$router.push({path: `/cokeBenzene/productPrice`, query: {id}})
      }
    },
    /**
     * 切换tabs
     */
    changeTabs(num) {
      this.flag = num;
      this.page = 1;
      this.getList();
    },
    /**
     * 回退
     */
    back() {
      this.$router.push('/cokeBenzene')
    },
    /**
     * 分页
     */
    goFirst() {
      this.page = 1;
      this.getList()
    },
    goLast() {
      this.page = Math.ceil(this.total / 15);
      this.getList()
    },
    changePage(page) {
      this.page = page;
      this.getList()
    },
  }
}
</script>

<style scoped lang="less">
@import "../../../style/twoPage";
</style>
